import {Message} from 'element-ui'

export const messageTooltip = (options) => {
  let defaultOptions = {
    showClose: false,
    duration:3000,
    type: 'warning',
    customClass: 'cargoee_message_tooltip'
  }

  setTimeout(() => {
    let nodeList = document.getElementsByClassName('cargoee_message_tooltip')
    let labelList = []

    // 过滤同样的msg
    for (let i = 0; i < nodeList.length; i++) {
      const item = nodeList[i]
      labelList.push(item.innerText)
    }
    if (labelList.includes(options.message)) {
      return
    }

    Message(Object.assign(defaultOptions, options))
    setTimeout(() => {
      // 设置样式
      nodeList = document.getElementsByClassName('cargoee_message_tooltip')
      for (let i = 0; i < nodeList.length; i++) {
        const item = nodeList[i]
        if (i === 0) {
          item.style.top = '50%'
          console.log(item.style.top)
        } else {
          console.log(`calc(50% - ${i * 50}px)`)
          item.style.top = `calc(50% - ${i * 50}px)`
        }
      }
    }, 50)
  }, 50)
}



// WEBPACK FOOTER //
// ./src/utils/messageUtil.js